import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { omnimizerApi } from "../api";
import { lifecycleState } from "../lifecycle";
import type { OmnimizerDeployment, PendingReason } from "../types";

const stepReason: Record<string, PendingReason> = { DOWNLOADING: "downloading_weights", LOADING: "loading" };
export function DeploymentStatusBadge({ deployment }: { deployment: OmnimizerDeployment }) {
  const { t } = useTranslation(); const state = lifecycleState(deployment);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => { if (state !== "starting") return; const timer = window.setInterval(() => setNow(Date.now()), 10000); return () => window.clearInterval(timer); }, [state]);
  const runtime = useQuery({ queryKey: ["omnimizer", "runtime", deployment.model_id],
    queryFn: () => omnimizerApi.runtimeStatus(deployment.model_id),
    enabled: state === "starting" && deployment.args?.runtime === "dynamo-vllm", refetchInterval: 5000, retry: false });
  const reason = runtime.data?.pending_reason || deployment.pending_reason || stepReason[deployment.current_step || ""] || "unknown";
  const started = Date.parse(runtime.data?.started_at || deployment.last_updated || deployment.created_at);
  const minutes = Number.isFinite(started) ? Math.max(0, Math.floor((now - started) / 60000)) : 0;
  return <span className="inline-flex flex-col items-start gap-1" role="status">
    <Badge variant={state === "running" ? "success" : state === "failed" ? "destructive" : "muted"}>{t(`omnimizer.lifecycle.${state}`)}</Badge>
    {state === "starting" && <span className="text-xs text-muted-foreground">{t(`omnimizer.lifecycle.reason.${reason}`)} · {t("omnimizer.lifecycle.elapsed", { minutes })}</span>}
  </span>;
}
